





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ModalBox extends Vue {
  @Prop({
    default: false,
  })
  public isActive!: boolean;

  @Prop({
    default: null,
  })
  public trashObjectName!: string;

  @Prop({
    default: false,
  })
  public isDeleting!: boolean;

  public isModalActive = false;

  public cancel(): void {
    this.$emit('cancel');
  }
  public confirm(): void {
    this.$emit('confirm');
  }

  @Watch('isActive')
  public onIsActiveChange(newValue: boolean): void {
    this.isModalActive = newValue;
  }

  @Watch('isModalActive')
  public onIsModalActiveChange(newValue: boolean): void {
    if (!newValue) {
      this.cancel();
    }
  }
}
